import OapPromoCard from './code/Scripts/components/OapPromoCard.vue';

export default {
  components: {
    OapPromoCard,
  },
};
